import styled from "styled-components";

export const D1 = styled.h1`
  font-family: "Satoshi-Variable", sans-serif;
  font-weight: 900;
  font-size: 24px;
  font-display: swap;
  font-style: normal;
  margin: 5px;
  color: ${(props) => props.color};
`;

export const H1 = styled.h1`
  font-family: "Satoshi-Variable", sans-serif;
  font-weight: 900;
  font-size: 20px;
  font-display: swap;
  color: ${(props) => props.color};
  margin: 0;
`;

// Body text styles per typography spec
export const P1 = styled.p`
  font-family: "Satoshi-Variable", sans-serif;
  font-weight: 600;
  font-size: 16px;
  font-display: swap;
  color: ${(props) => props.color};
  margin: ${(props) => (props.margin ? props.margin : "0")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "1.5")};
`;

export const P2 = styled.p`
  font-family: "Satoshi-Variable", sans-serif;
  font-weight: ${(props) => (props.bold ? 900 : 400)};
  font-size: 15px;
  font-display: swap;
  color: ${(props) => props.color};
  margin: 0 0 5px;
`;

export const P3 = styled.p`
  font-family: "Satoshi-Variable", sans-serif;
  font-weight: 400;
  font-size: 13px;
  font-display: swap;
  color: ${(props) => props.color};
  margin: 0;
`;

export const Span = styled.span`
  font-display: swap;
  color: ${(props) => props.color};
`;

export const GradientSpan = styled.span`
  background: ${(props) =>
    `linear-gradient(120deg, ${props.$background}, ${props.$transitionBackground})`};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
`;
